import styled from "styled-components";
import { Link, Paper, TextField} from "@mui/material";
import Logo from "../../../assets/images/Logo.svg";
import Background from "../../../assets/images/BackgroundImg.svg";
import ButtonLoading from "../../../components/buttonLoading";

export const BackGround = styled.div`
  width: 100vw;
  height: 100vh;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  background-image: url(${Background});
  justify-content: center;
`;

export const DivText = styled.div`
  flex-direction: column;
  display: flex;
  flex: 1;
  align-items: center;
  justify-content: space-between;
`;

export const DivForm = styled.form`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  flex: 1;
  align-items: center;
`;

export const InputsContainer = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
`;

export const InputsContainerButtons = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column-reverse;
`;

export const CenterInputs = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  align-items: center;
  justify-content: center;

`;

export const ImagemLogin = styled.div`
  width: 204px;
  height: 78px;
  flex: none;
  background-image: url(${Logo});
  order: 0;
  flex-grow: 0;
  z-index: 2;
`;

export const PaperLogin = styled(Paper)`
  && {
    align-items: center;
    justify-content: space-between;
    display: flex;
    flex-direction: column;
    color: black;
    background-color: white;
    border-color: black;
    height: 421px;
    width: 423px !important;
    border-radius: 10px;
    border-right: 40px solid #1f299c;
    padding: 30px 0;
  }
`;

export const  TextFieldLogin = styled(TextField)`
 &&{
   width: 250px;
   height: 65px;
 } 
`;

export const LinkLogin = styled(Link)`
  &&{
    margin-top: 15px;
    color: #FE4C01;
    font-size: 15px;
    cursor: pointer;
  }
`;

export const ButtonLogin = styled(ButtonLoading)`
  order: 2;
  width: 253px;
  height: 44px;
  &&{
    color: white;
    min-width: 253px;
    background-color: #1f299c;
    font-size: 14px;
    :hover{
      background-color: #0665ff;
    }
  }
  
`;

